<template>
	<div>
		<div class="answer-block">
			<div v-if="!email_shown">
				<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">How do I redeem?</h1>
				<p>
					Please visit your <a class="help-link" href="/account/elibrary.php" target="_blank">eLibrary page</a> for redemption instructions
				</p>
				<div>
					<v-btn color="#7DADED" large round dark @click="showEmailForm">I followed the instructions but it’s not working</v-btn>
					<v-btn color="#7DADED" large round dark to="/that_worked">That worked!</v-btn>
				</div>
			</div>

			<div v-else>
				<email-form
						subject="I can't redeem my ebook"
						:body="email_body"
						on-success-url="/help?#/submitted"
						edit-body
						must-edit
						attach-screenshot
						require-screenshot
						destination-key="oq"
						:payload="{ order_line_id }"
				></email-form>
			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';
	import Axios from 'axios';

	export default {
		name: "HowToRedeem",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				email_shown: false,
				order_id: '',
				order_line_id: '',
			};
		},

		computed: {
			email_body() {
				return `I am trying to redeem my code, but I am getting an error: `;
			}
		},

		methods: {
			showEmailForm() {

				const self = this;
				self.loading = true;

				Axios.get('/service/customer_help/rest/index.php/customer_help/get_product_detail/' + parseInt(self.$route.params.id))
					.then(function (response) {
						if (response.status === 200 && response.data && response.data['status'] === 'success') {
							let d = response['data']['data'];
							self.isbn = d['product_isbn'];
							self.order_id = d['order_id'];
							self.order_line_id = d['order_line_id'];
							self.email_shown = true;
						}
					})
					.finally(function () {
						self.loading = false;
					});
			}
		},
	}
</script>

<style scoped>

</style>